import { combineReducers } from 'redux';
import { headReducer } from '../head';
import { contentReducer } from '../content';
import { contactReducer } from '../contact';
import { productReducer } from '../product';
import { cmsReducer } from '../cms';

const app = combineReducers({
	head: headReducer,
	content: contentReducer,
	contact: contactReducer,
	product: productReducer,
	cms: cmsReducer,
});

export default app;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js